module.exports = {
	"Announcement": {
		"Know More": "자세히 보기"
	},
	"Appointment": {
		"Conditions": "“확인”을 클릭하면 귀하가 개인정보 처리방침을 읽었으며 이에 명시된 조건 하에서 크리스챤 디올 꾸뛰르가 개인 정보를 활용하여 귀하의 요청 사항을 처리해 드리는 서비스를 제공하는 것에 동의한다고 간주합니다.",
		"Confirmation": "디올 부띠크에서 디올 상담원이 제공하는 개인 맞춤 서비스 예약 요청이 접수되었습니다. 곧 확인 이메일을 전송해 드리겠습니다.",
		"Description": "디올 부띠크에서 디올 상담원에게 개인 맞춤 상담 서비스를 받아보시기 바랍니다.",
		"Get an appointment": "부띠크 방문 예약하기",
		"Motives": "방문 목적",
		"Universes": "관심 카테고리"
	},
	"DiorMap": {
		"Search in this area": "이 지역에서 검색하기"
	},
	"FilterBlock": {
		"%(count)s Results": {
			"one": "%(count)s 결과",
			"other": "%(count)s 결과",
			"zero": "%(count)s 결과"
		},
		"Refine": "정렬",
		"RefineAria": "아래의 체크박스를 이용하여 검색 조건을 설정하세요.",
		"Are you looking for?": "여성 패션, 남성 패션, 아동 패션, 또는 주얼리 및 타임피스 관련 부티크를 찾고 계신가요?"
	},
	"Footer": {
		"Download the applications": "애플리케이션 다운로드하기",
		"Language": "언어",
		"Newsletter": "예시: Christian@dior.fr",
		"Ok": "확인",
		"Subscribe to newsletter": "뉴스레터 신청하기"
	},
	"Form": {
		"All fields are mandatory": "모든 항목은 필수 입력 사항입니다.",
		"Civility": "타이틀",
		"Comments": "내용",
		"Conditions": "%(brand)s 에서 발송하는 확인 이메일을 받아 보고자 하시는 경우, 위의 항목을 체크해 주시기 바랍니다. 이용 고객은 \"contact@dior.com”으로 이메일을 발송하여 본인과 관련된 정보를 확인, 수정, 삭제, 반대할 권리를 행사할 수 있습니다.",
		"Date": "희망 일자",
		"Email": "이메일",
		"Hour": "희망 시간",
		"Invalid E-mail address": "잘못된 이메일 주소",
		"Mr": "Mr",
		"Mrs": "Mrs",
		"Name": "성",
		"Phone": "전화번호",
		"Required fields": "필수 입력 사항",
		"Submit": "확인",
		"Surname": "이름"
	},
	"HeaderLight": {
		"Dior Boutiques near you: haute couture, fragrances, leather goods": "가까운 디올 부띠크에서 오뜨 꾸뛰르와 퍼퓸, 그리고 가죽 제품을 만나보세요.",
		"Search for Dior shops": "Search for Dior shops",
		"Dior home logo": "DIOR home logo",
		"close boutique finder dialog": "close boutique finder dialog"
	},
	"Itinerary": {
		"Arrival": "도착",
		"Departure": "출발",
		"Details": "상세 정보",
		"Error": "죄송합니다. 요청하신 경로를 찾을 수 없습니다. 출발지 및/또는 선택하신 교통수단을 변경하여 다시 시도해 주시기 바랍니다.",
		"Follow the itinerary": "경로 확인",
		"Itinerary": "경로",
		"modeBICYCLING": "자전거 이용으로 변경",
		"modeDRIVING": "자동차 이용으로 변경",
		"modeTRANSIT": "대중교통 이용으로 변경",
		"modeWALKING": "도보 이용으로 변경",
		"Close dialog": "close dialog",
		"Print directions": "print directions"
	},
	"LayerOrientation": {
		"Use portrait": "휴대 전화를 세로 모드로 사용하십시오."
	},
	"NavMobile": {
		"Home": "홈"
	},
	"Newsletter": {
		"Dior Newsletter": "디올 뉴스레터",
		"Fashion and accessories": "패션 & 액세서리",
		"I wish to receive the %(newsletter)s newsletter": "디올 하우스의 %(newsletter)s 관련 새로운 소식을 받아보겠습니다.",
		"Newsletter Confirmation": "뉴스레터 구독 신청이 완료되었습니다.",
		"Perfume and beauty": "향수 & 뷰티",
		"Receive our newsletter": "뉴스레터를 구독하세요.",
		"Your universes": "당신의 세계"
	},
	"ResultsBlock": {
		"Dior boutiques": "디올 부띠크",
		"Too far": "검색 결과가 너무 많습니다. 범위를 좁혀 검색 조건을 세분화해주세요.",
		"No result": "부띠크를 찾지 못했습니다.",
		"Other shops": "다른 부띠크",
		"Results": "검색 결과",
		"Fewer results, zoom in": "제한된 결과보기, zoom in",
		"More results, zoom out": "더 알아보기, zoom out",
		"Fewer results": "제한된 결과보기",
		"More results": "더 알아보기"
	},
	"SearchBlock": {
		"Geolocation": "위치 서비스를 이용하여 가까이에 있는 부띠크를 찾아보세요.",
		"Search": "검색"
	},
	"Share": {
		"Conditions": "“확인”을 클릭하면 귀하는 개인정보 처리방침을 읽었으며 이에 명시된 조건 하에서 크리스챤 디올 꾸뛰르가 개인 정보를 활용하여 귀하의 요청 사항을 처리해 드리는 서비스를 제공하는 것에 동의하는 것으로 간주합니다. 또한, 해당란에 체크 표시를 하면 크리스챤 디올 꾸뛰르가 귀하의 선호도를 포함한 개인정보를 기반으로 수집한 데이터를 다이렉트 마케팅에 활용하는 것에 동의하는 것으로 간주합니다.",
		"Recipient": "수신인",
		"Share Confirmation": "고객님의 부띠크 정보가 전송되었습니다.",
		"Share this shop": "부띠크 정보 공유하기",
		"Your favorite shop": "선호하는 부띠크"
	},
	"ShopBlock": {
		"Closed": "CLOSED",
		"Closed today": "오늘 그만보기",
		"Directions": "경로",
		"DirectionsAria": "%(shopName)s로 경로 안내",
		"Make an appointment": "부띠크 방문 예약하기",
		"Open": "오픈",
		"Opening time": "영업 시간",
		"OpeningAria": "오픈 정보 자세히 보기",
		"ResultNumber": "결과 번호%(number)s",
		"Services": "서비스",
		"ServicesAria": "서비스 자세히 보기",
		"Share": "공유하기",
		"Special hours": "Special hours",
		"Today until %(hour)s": "오늘 %(hour)s 까지",
		"Universes": "유니버스",
		"UniversesAria": "관련 유니버스 자세히 보기",
		"and": "and",
		"from": "from",
		"publicHolidays": "해당 부띠크는 연휴 기간 동안 오픈하지 않을 예정입니다.",
		"to": "to"
	}
};


//////////////////
// WEBPACK FOOTER
// ./public/assets/locales/ko_kr/translations.json
// module id = 869
// module chunks = 0